<content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed"
                [preserveAspectRatio]="preserveAspectRatio" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [uniqueKey]="uniqueKey">
  <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10"/>
</content-loader>
